/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .factory('publicFolderLinkShareModal', [
        '$rootScope',
        '$translate',
        'modalAction',
        function (
            $rootScope,
            $translate,
            modalAction
        ) {
        return function (publicFolderLink) {
            modalAction($rootScope.$new(), {
                modalController: 'PublicFolderLinkShareModalController',
                modalClass: 'public-link-share-dialog',
                modalType: 'confirm',
                modalTitle: $translate.instant('public_folders_share_link_modal_title'),
                modalSize: 'xl',
                modalBodyTemplate: 'modals/actions/public_folder_share_link',
                modalFooterTemplate: 'modals/actions/public_folder_share_link_footer',
                resolve: {
                    publicFolderLink: function() {
                        return publicFolderLink;
                    }
                }
            });
        }
    }]);
